import { __awaiter, __generator } from "tslib";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var debounce = function (func, wait) {
    var timeout;
    return function () {
        var rest = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            rest[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var context, later;
            return __generator(this, function (_a) {
                context = this;
                later = function () {
                    timeout = null;
                    func.apply(context, rest);
                };
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(later, wait);
                return [2 /*return*/];
            });
        });
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVib3VuY2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9jb21wb25lbnRzL2F1dG9jb21wbGV0ZS91dGlscy9kZWJvdW5jZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsOERBQThEO0FBQzlELE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFrQixJQUE0QixFQUFFLElBQVk7SUFDbEYsSUFBSSxPQUE4QixDQUFBO0lBQ2xDLE9BQU87UUFBTyxjQUFVO2FBQVYsVUFBVSxFQUFWLHFCQUFVLEVBQVYsSUFBVTtZQUFWLHlCQUFVOzs7OztnQkFFaEIsT0FBTyxHQUFtQyxJQUFJLENBQUE7Z0JBQzlDLEtBQUssR0FBRztvQkFDWixPQUFPLEdBQUcsSUFBSSxDQUFBO29CQUNkLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxDQUFBO2dCQUMzQixDQUFDLENBQUE7Z0JBQ0QsSUFBSSxPQUFPLEVBQUU7b0JBQ1gsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFBO2lCQUN0QjtnQkFDRCxPQUFPLEdBQUcsVUFBVSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsQ0FBQTs7OztLQUNsQyxDQUFBO0FBQ0gsQ0FBQyxDQUFBIn0=